export function getProjectIdFromDiscussionSocketPayload(payload) {
    if (!payload) return null;
    return (
        payload.projectId ??
        payload.project_id ??
        payload?.project?.id ??
        payload?.post?.projectId ??
        payload?.post?.project_id ??
        null
    );
}

export function getPostFromDiscussionSocketPayload(payload) {
    if (!payload) return null;
    return payload?.post ?? payload;
}

export function getBlockerIdFromDiscussionSocketPayload(payload) {
    if (!payload) return null;
    return (
        payload.blockerId ??
        payload.blocker_id ??
        payload.taskBlockerId ??
        payload.task_blocker_id ??
        payload?.blocker?.id ??
        payload?.taskBlocker?.id ??
        payload?.task_blocker?.id ??
        null
    );
}

